/**
 * Dev-only structured logger. Silent by default. Opt-in via DevTools:
 *   localStorage.setItem("devLog", "1")    // enable
 *   localStorage.removeItem("devLog")      // disable
 * Reload after toggling. Used by SCM load chain (ProjectARView, ShowToolMenu,
 * DesignManager, scmWorker bridge) so multi-step async flows can be traced
 * without permanent console spam.
 */
const ENABLED =
  typeof localStorage !== "undefined" &&
  localStorage.getItem("devLog") === "1";

export function devLog(label: string, data?: unknown): void {
  if (!ENABLED) return;
  if (data === undefined) {
    console.log(`[dev] ${label}`);
  } else {
    console.log(`[dev] ${label}`, data);
  }
}
